import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "../mobile/Mobile.module.scss";
export class Modile extends Component {
  static propTypes = {};

  render() {
    const websiteInfo = [
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/15940646326028382.png",
        name: "Nano Website Design",
        pra: "3 - 4 NOS. OF WEB PAGES",
        infoList: [
          {
            list: " Excellent Responsive Website",
          },
          {
            list: " Mobile Responsive Layout",
          },
          {
            list: " Facebook Page Integration",
          },
          {
            list: " Youtube Page Integration",
          },
          {
            list: " Instagram Page Integration",
          },
          {
            list: " Whatsapp Chat Integration",
          },
          {
            list: " 1 Email IDs for Outlook.",
          },
          {
            list: " Free Web Hosting for 1 Year",
          },
          {
            list: " Free Domain for 1 Year",
          },
        ],
        del: "Delivery in :",
        day: "7day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/15940646326028382.png",
        name: "Nano Website Design",
        pra: "3 - 4 NOS. OF WEB PAGES",
        infoList: [
          {
            list: " Excellent Responsive Website",
          },
          {
            list: " Mobile Responsive Layout",
          },
          {
            list: " Facebook Page Integration",
          },
          {
            list: " Youtube Page Integration",
          },
          {
            list: " Instagram Page Integration",
          },
          {
            list: " Whatsapp Chat Integration",
          },
          {
            list: " 1 Email IDs for Outlook.",
          },
          {
            list: " Free Web Hosting for 1 Year",
          },
          {
            list: " Free Domain for 1 Year",
          },
        ],
        del: "Delivery in :",
        day: "7day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/15940646326028382.png",
        name: "Nano Website Design",
        pra: "3 - 4 NOS. OF WEB PAGES",
        infoList: [
          {
            list: " Excellent Responsive Website",
          },
          {
            list: " Mobile Responsive Layout",
          },
          {
            list: " Facebook Page Integration",
          },
          {
            list: " Youtube Page Integration",
          },
          {
            list: " Instagram Page Integration",
          },
          {
            list: " Whatsapp Chat Integration",
          },
          {
            list: " 1 Email IDs for Outlook.",
          },
          {
            list: " Free Web Hosting for 1 Year",
          },
          {
            list: " Free Domain for 1 Year",
          },
        ],
        del: "Delivery in :",
        day: "7day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
    ];
    return (
      <div>
        <section className={styles.website}>
          {websiteInfo.map((web) => {
            return (
              <div>
                <div className={styles.wrap}>
                  <div className={styles.imgs}>
                    <img src={web.url} alt="" />
                  </div>
                  <div className={styles.info}>
                    <h2>
                      <Link
                        href="online-product/nano-website-design"
                        class="th-color"
                      >
                        {web.name}
                      </Link>
                    </h2>
                    <p>{web.pra}</p>
                    <ul>
                      {web.infoList.map((weblist) => {
                        return <li>{weblist.list}</li>;
                      })}
                    </ul>
                  </div>
                  <div className={styles.btn_grp}>
                    <h3>
                      {web.del} <span>{web.day}</span>{" "}
                    </h3>
                    <button>{web.butonOne}</button>
                    <button>{web.buttonTwo}</button>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
        <section className={styles.website_mobile}>
          <div className="container">
            <div className={styles.back_button}>
              <Link to="/service">
                <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
              </Link>
            </div>
            {websiteInfo.map((web) => {
              return (
                <div>
                  <div className={styles.wrap}>
                    <div className={styles.imgs}>
                      <img src={web.url} alt="" />
                    </div>
                    <div className={styles.info}>
                      <h2>
                        <Link
                          href="online-product/nano-website-design"
                          class="th-color"
                        >
                          {web.name}
                        </Link>
                      </h2>
                      <p>{web.pra}</p>
                      <div className={styles.btn_grp}>
                        <h3>
                          {web.del} <span>{web.day}</span>{" "}
                        </h3>
                        <button>{web.butonOne}</button>
                        <button>{web.buttonTwo}</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    );
  }
}

export default Modile;
